import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openWishlistModal } from '../modules/active_modal';

class IconWishlistState extends Component {
  render() {
    let counter = '';
    let {dispatch} = this.props;
    let iconWishlist = (
      <svg version="1.1" id="Layer_1" x="0px" y="0px" width="33px" height="33px" viewBox="0 0 864 864" enable-background="new 0 0 864 864">
        <path fill="#A2B4B8" d="M829.612,182.687c-150.448-229.97-369.672-21.492-391.165-2.149
          c-19.343-19.343-247.164-229.97-397.611,2.149c-146.149,223.522,303.045,580.299,389.015,612.537v2.149c0,0,0,0,0-2.149v2.149
          v-2.149C515.821,762.985,975.762,406.209,829.612,182.687z"/>
      </svg>
      )
    if ( this.props.customer && this.props.customer.wishlist
      && this.props.customer.wishlist.length > 0) {
        counter = <span className="round-counter">{this.props.customer.wishlist.length}</span>;
    }

    return (
      <span className="icon-holder wishlist unselectable" onClick={() => dispatch( openWishlistModal() )}>
        {counter}
        {iconWishlist}
        <div className="menu-nav-text">Wishlist</div>
      </span>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(IconWishlistState);


// WEBPACK FOOTER //
// ./src/components/IconWishlistState.jsx